export default{
    "warning.versionOverlapping" : "Une nouvelle version de l'application a été publiée. Vous serez redirigé vers la nouvelle version.",
    "warning.418"                : "Une nouvelle version est disponible",
    "warning.418.info"           : "L'application se rafraîchira dans 5 secondes",
}